const getLocalRefreshToken = () => {
  const user = JSON.parse(localStorage.getItem("user") as string);
  return user?.RefreshToken;
};

const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem("user") as string);
  return user?.AccessToken;
};

const getExpiresIn = () => {
  const user = JSON.parse(localStorage.getItem("user") as string);
  return String(user.ExpiresIn);
};

const updateLocalAccessToken = (AccessToken: string) => {
  let user = JSON.parse(localStorage.getItem("user") as string);
  user.AccessToken = AccessToken;
  localStorage.setItem("user", JSON.stringify(user));
};

const updateLocalRefreshToken = (RefreshToken: string) => {
  let user = JSON.parse(localStorage.getItem("user") as string);
  user.RefreshToken = RefreshToken;
  localStorage.setItem("user", JSON.stringify(user));
};

const getUser = () => {
  return JSON.parse(localStorage.getItem("user") as string);
};

const setUser = (user: any) => {
  localStorage.setItem("user", JSON.stringify(user));
};

const removeUser = () => {
  localStorage.removeItem("user");
  localStorage.removeItem('activeParent')
};

const tokenManager = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  updateLocalRefreshToken,
  getUser,
  setUser,
  removeUser,
  getExpiresIn,
};

export default tokenManager;
